export { default as EmojiInput } from './components/emoji-input/EmojiInput';
export type { EmojiInputRef, EmojiInputProps } from './components/emoji-input/EmojiInput';
export type { ReplaceTextOptions } from './utils/selection';
export { default as EmojiPickerPopup } from './components/emoji-picker-popup/EmojiPickerPopup';
export { default as EmojiPicker } from './components/emoji-picker/EmojiPicker';
export { PopupAlignment } from './constants/alignment';
export { escapeHTML, unescapeHTML } from './utils/emoji';
export {
    loadEmojiShortList,
    convertEmojisToUnicodeAsync,
    convertEmojiToUnicodeSync,
} from './utils/convertEmojisToUnicodeAsync';
